import { configureStore, combineReducers } from "@reduxjs/toolkit";
import workerReducer from "./worker/workerSlice";
import UserSlice from "./user/userSlice";
import leadReducer from "./lead/leadSlice";
import conversationSlice from "./conversation/conversationSlice";
import TeamLeadSlice from "./teamLead/teamLeadSlice";

const rootReducer = combineReducers({
  worker: workerReducer,
  user: UserSlice,
  usersDetails: UserSlice,
  leads: leadReducer,
  team_lead: TeamLeadSlice,
  conversations: conversationSlice,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export { store };
